import { createAction } from '/@/store/utils';

export const setCampaignFrom = createAction('CARBON_CALCULATOR:SET_CAMPAIGN_FROM');
export const setCampaignTo = createAction('CARBON_CALCULATOR:SET_CAMPAIGN_TO');
export const setCampaigns = createAction('CARBON_CALCULATOR:SET_CAMPAIGNS');
export const setSelectedCampaigns = createAction('CARBON_CALCULATOR:SET_SELECTED_CAMPAIGNS');
export const setSelectedCampaign = createAction('CARBON_CALCULATOR:SET_SELECTED_CAMPAIGN');
export const setFarmingType = createAction('CARBON_CALCULATOR:SET_FARMING_TYPE');
export const setAllFarmingTypes = createAction('CARBON_CALCULATOR:SET_ALL_FARMING_TYPES');
export const setSoiltype = createAction('CARBON_CALCULATOR:SET_SOIL_TYPE');
export const setAllSoilTypes = createAction('CARBON_CALCULATOR:SET_ALL_SOIL_TYPES');
export const setAllCrops = createAction('CARBON_CALCULATOR:SET_ALL_CROPS');
export const setClay = createAction('CARBON_CALCULATOR:SET_CLAY');
export const setOrganicMaterial = createAction('CARBON_CALCULATOR:SET_ORGANIC_MATERIAL');
export const setDensity = createAction('CARBON_CALCULATOR:SET_DENSITY');
export const setCalculationResult = createAction('CARBON_CALCULATOR:SET_CALCULATION_RESULT');
